// ['booked', 'completed', 'cancelled', 'no show']
export const VISIT_STATUS_BOOKED = 'booked';
export const VISIT_STATUS_COMPLETED = 'completed';
export const VISIT_STATUS_CANCELLED = 'cancelled';
export const VISIT_STATUS_NO_SHOW = 'no show';

export const VISIT_STATUS__VALUES = [
  VISIT_STATUS_BOOKED,
  VISIT_STATUS_COMPLETED,
  VISIT_STATUS_CANCELLED,
  VISIT_STATUS_NO_SHOW,
];
